import { AlignHighlightModel } from '@/editor/entities/2d/alignHighlightModel';
import { AlignLine } from '@/editor/entities/2d/alignLine';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { getRotatedRectangleVertices } from '@/editor/math/utils';
import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';

export class AlignManager {
  private _alignSeg: AlignLine;
  private _alignMask: AlignHighlightModel;

  constructor() {
    this._alignSeg = new AlignLine();
    this._alignMask = new AlignHighlightModel();
  }

  updateAlignLine(startPoint: IPoint2d, endPoint: IPoint2d) {
    this._alignSeg.updateAdsorbLine(startPoint, endPoint);
  }

  setAlignLineVisible(visible: boolean) {
    this._alignSeg.visible = visible;
  }

  updateAlignReference(entityInfo?: { entityId: string; type: EEntityType }) {
    globalStores.editorStateStore.updateAlignReference(entityInfo);
    this._updateAlignReferenceMask(entityInfo);
  }

  private _updateAlignReferenceMask(entityInfo?: { entityId: string; type: EEntityType }) {
    this._alignMask.update([]);
    if (!entityInfo) {
      return;
    }
    const data =
      entityInfo.type === EEntityType.Assembly
        ? globalStores.assemblyStore.getAssemblyData(entityInfo.entityId)
        : globalStores.modelStore.getFurnitureData(entityInfo.entityId);
    if (!data) {
      this._alignMask.update([]);
      return;
    }
    const { center, width, thickness, rotation } = data;
    const boundsBox = getRotatedRectangleVertices(width, thickness, center, rotation);
    this._alignMask.update(boundsBox);
  }
}
